import {
  Add01Icon,
  AdvertisimentIcon,
  Alert01Icon,
  AlertCircleIcon,
  AlertDiamondIcon,
  AnalysisTextLinkIcon,
  ArrowDataTransferDiagonalIcon,
  ArrowDown01Icon,
  ArrowDownRight01Icon,
  ArrowExpandDiagonal01Icon,
  ArrowHorizontalIcon,
  ArrowLeft01Icon,
  ArrowRight01Icon,
  ArrowRight02Icon,
  ArrowUp01Icon,
  ArrowUpRight01Icon,
  Calendar03Icon,
  Cancel01Icon,
  CancelCircleIcon,
  ChartBarLineIcon,
  ChartUpIcon,
  Check,
  CheckListIcon,
  CheckmarkCircle01Icon,
  CheckmarkCircle02Icon,
  CircleIcon,
  Clock01Icon,
  ColorPickerIcon,
  ComputerIcon,
  ConnectIcon,
  ContractsIcon,
  Copy01Icon,
  Csv01Icon,
  DashboardSquare02Icon,
  Database01Icon,
  Delete01Icon,
  Delete02Icon,
  Download01Icon,
  Download03Icon,
  Edit01Icon,
  Edit02Icon,
  EyeIcon,
  File01Icon,
  FileNotFoundIcon,
  FileScriptIcon,
  FileUploadIcon,
  FilterHorizontalIcon,
  FilterIcon,
  FlashIcon,
  GlobeIcon,
  GoogleDocIcon,
  Home01Icon,
  ImageAdd02Icon,
  InformationCircleIcon,
  Key01Icon,
  Link05Icon,
  Loading01Icon,
  Loading02Icon,
  Loading03Icon,
  LockIcon,
  Logout01Icon,
  Mail01Icon,
  Megaphone01Icon,
  Menu01Icon,
  Mining02Icon,
  Moon02Icon,
  MoreHorizontalIcon,
  Notification01Icon,
  PanelLeftCloseIcon,
  PanelLeftOpenIcon,
  PauseIcon,
  PetrolPumpIcon,
  PlayIcon,
  PlusSignCircleIcon,
  ReceiptDollarIcon,
  Refresh01Icon,
  Remove01Icon,
  Search01Icon,
  Search02Icon,
  Settings02Icon,
  Share04Icon,
  Shield01Icon,
  SmartphoneWifiIcon,
  SparklesIcon,
  SquareArrowUpRight02Icon,
  Sun02Icon,
  Tick01Icon,
  Tick02Icon,
  Upload02Icon,
  User02Icon,
  UserCircleIcon,
  ViewOffIcon,
  Wallet01Icon,
  Wrench01Icon,
  ZapIcon,
} from "@hugeicons/core-free-icons"

/**
 * Design system icons via @hugeicons/react + @hugeicons/core-free-icons.
 * Use HugeiconsIcon with these icon objects for consistent styling.
 * Default strokeWidth is 2; pass strokeWidth to override.
 */
import { HugeiconsIcon as HugeiconsIconBase } from "@hugeicons/react"

export function HugeiconsIcon(
  props: React.ComponentProps<typeof HugeiconsIconBase>
) {
  return <HugeiconsIconBase {...props} strokeWidth={props.strokeWidth ?? 2} />
}

export const Icons = {
  Add01: Add01Icon,
  Advertisiment: AdvertisimentIcon,
  Alert01: Alert01Icon,
  AlertCircle: AlertCircleIcon,
  AlertDiamond: AlertDiamondIcon,
  ArrowDown01: ArrowDown01Icon,
  ArrowDownRight01: ArrowDownRight01Icon,
  ArrowExpandDiagonal01: ArrowExpandDiagonal01Icon,
  ArrowHorizontal: ArrowHorizontalIcon,
  ArrowLeft01: ArrowLeft01Icon,
  ArrowRight01: ArrowRight01Icon,
  ArrowRight02: ArrowRight02Icon,
  ArrowUp01: ArrowUp01Icon,
  ArrowUpRight01: ArrowUpRight01Icon,
  Calendar03: Calendar03Icon,
  Cancel01: Cancel01Icon,
  CancelCircle: CancelCircleIcon,
  ChartBarLine: ChartBarLineIcon,
  ChartUp: ChartUpIcon,
  Circle: CircleIcon,
  Clock01: Clock01Icon,
  ColorPicker: ColorPickerIcon,
  Check: Check,
  Database01: Database01Icon,
  Globe: GlobeIcon,
  Key01: Key01Icon,
  Mail01: Mail01Icon,
  Tick01: Tick01Icon,
  Tick02: Tick02Icon,
  User02: User02Icon,
  ViewOff: ViewOffIcon,
  CheckmarkCircle01: CheckmarkCircle01Icon,
  CheckmarkCircle02: CheckmarkCircle02Icon,
  Computer: ComputerIcon,
  Copy01: Copy01Icon,
  DashboardSquare02: DashboardSquare02Icon,
  Delete01: Delete01Icon,
  Delete02: Delete02Icon,
  Download01: Download01Icon,
  Download03: Download03Icon,
  Edit01: Edit01Icon,
  Edit02: Edit02Icon,
  Eye: EyeIcon,
  FilterHorizontal: FilterHorizontalIcon,
  File01: File01Icon,
  FileScript: FileScriptIcon,
  FileUpload: FileUploadIcon,
  Upload02: Upload02Icon,
  Home01: Home01Icon,
  InformationCircle: InformationCircleIcon,
  Link05: Link05Icon,
  Loading01: Loading01Icon,
  Loading02: Loading02Icon,
  Lock: LockIcon,
  Logout01: Logout01Icon,
  Megaphone01: Megaphone01Icon,
  Menu01: Menu01Icon,
  Moon02: Moon02Icon,
  MoreHorizontal: MoreHorizontalIcon,
  Notification01: Notification01Icon,
  ReceiptDollar: ReceiptDollarIcon,
  Refresh01: Refresh01Icon,
  Search01: Search01Icon,
  Search02: Search02Icon,
  Settings02: Settings02Icon,
  Shield01: Shield01Icon,
  SmartphoneWifi: SmartphoneWifiIcon,
  Sparkles: SparklesIcon,
  Sun02: Sun02Icon,
  Wallet01: Wallet01Icon,
  Wrench01: Wrench01Icon,
  Zap: ZapIcon,
  PetrolPump: PetrolPumpIcon,
  GoogleDoc: GoogleDocIcon,
  AnalysisTextLink: AnalysisTextLinkIcon,
  PlusSignCircle: PlusSignCircleIcon,
  SquareArrowUpRight: SquareArrowUpRight02Icon,
  UserCircle: UserCircleIcon,
  Connect: ConnectIcon,
  Flash: FlashIcon,
  Csv01: Csv01Icon,
  Loading03: Loading03Icon,
  Share04: Share04Icon,
  ImageAdd02: ImageAdd02Icon,
  Play: PlayIcon,
  Pause: PauseIcon,
  CheckList: CheckListIcon,
  Filter: FilterIcon,
  Contracts: ContractsIcon,
  ArrowDataTransferDiagonal: ArrowDataTransferDiagonalIcon,
  Mining02: Mining02Icon,
  Remove01: Remove01Icon,
  PanelLeftOpen: PanelLeftOpenIcon,
  PanelLeftClose: PanelLeftCloseIcon,
  FileNotFound: FileNotFoundIcon,
} as const

export type IconName = keyof typeof Icons

interface IconProps {
  icon: (typeof Icons)[IconName]
  size?: number
  className?: string
  color?: string
  strokeWidth?: number
}

export function Icon({
  icon,
  size = 24,
  className,
  color = "currentColor",
  strokeWidth = 2,
}: IconProps) {
  return (
    <HugeiconsIcon
      icon={icon}
      size={size}
      color={color}
      strokeWidth={strokeWidth}
      className={className}
    />
  )
}
